import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { STRINGS } from "./i18n";
import { DEFAULT_CONTENT } from "./defaults";
import { SECTION_BACKGROUNDS, themeVal } from "./theme";

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("pgp_lang") || "fr");
  const [content, setContent] = useState({});

  useEffect(() => {
    localStorage.setItem("pgp_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    api
      .get("/content")
      .then((r) => setContent(r.data.items || {}))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--font-scale", themeVal(content, "font_scale"));
    root.style.setProperty("--font-title", themeVal(content, "font_title"));
    root.style.setProperty("--font-body", themeVal(content, "font_body"));
    root.style.setProperty("--txt", themeVal(content, "text_color"));
    root.style.setProperty("--accent", themeVal(content, "accent"));
    SECTION_BACKGROUNDS.forEach((s) =>
      root.style.setProperty(`--sec-${s.id}-bg`, themeVal(content, `bg_${s.id}`))
    );
  }, [content]);

  const c = (key) => content[key]?.[lang] ?? DEFAULT_CONTENT[key]?.[lang] ?? "";
  const t = (key) => STRINGS[lang]?.[key] ?? STRINGS.fr[key] ?? key;

  return (
    <AppCtx.Provider value={{ lang, setLang, c, t, content, setContent }}>
      {children}
    </AppCtx.Provider>
  );
}

export const useApp = () => useContext(AppCtx);

export const scrollToSection = (selector) => {
  const el = document.querySelector(selector);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
